@if (shouldRender()) {
<section class="block-featured" [attr.aria-label]="title()">
  <div class="block-featured__inner">
    <div class="block-featured__header">
      <h2 class="block-featured__title">{{ title() }}</h2>
      <a class="block-featured__view-all" [routerLink]="categoryLink()">
        Ver todos
        <app-icon [icon]="arrowRight" [size]="16" />
      </a>
    </div>

    <div class="block-featured__content">
      <div class="block-featured__grid">
        @for (product of products(); track product.id) {
          <app-product-card
            [product]="product"
            (addToCart)="addToCart.emit($event)"
            (zoomOpen)="zoomOpen.emit($event)"
            (notifyRequest)="notifyRequest.emit($event)"
            (notifyCancel)="notifyCancel.emit($event)"
            (cardClick)="cardClick.emit($event)"
            (reserveClick)="reserveClick.emit($event)"
          />
        }
      </div>

      @if (bannerImage(); as img) {
        <a class="block-featured__banner" [routerLink]="categoryLink()">
          <img
            class="block-featured__banner-img"
            [src]="img"
            [alt]="bannerAlt()"
            loading="lazy"
          />
          <div class="block-featured__banner-overlay">
            <span class="block-featured__banner-kicker">Perrón Store</span>
            <h3 class="block-featured__banner-heading">{{ title() }}</h3>
            <span class="block-featured__banner-cta">
              Explorar
              <app-icon [icon]="arrowRight" [size]="16" />
            </span>
          </div>
        </a>
      }
    </div>
  </div>
</section>
}
